import { SimpleGrid, Stack, Text } from '@chakra-ui/react';

import { ContactCard } from '../ContactCard';
import { ContactHit, useSimpleContactSearch } from './Context';

export const SelectedContacts = () => {
  const { selectedContacts, checkIsSelected, onRemoveContact } = useSimpleContactSearch();

  const renderContactCard = (contact: ContactHit) => {
    if (!contact) return null;
    const isSelected = checkIsSelected?.(contact);

    return <ContactCard key={contact.id} contact={contact} isSelected={isSelected} onRemove={onRemoveContact} />;
  };

  if (!selectedContacts?.length) {
    return (
      <Stack alignItems="center" justifyItems="center" pb={2}>
        <Text fontSize="xs" opacity="0.7">
          No Contacts Selected
        </Text>
      </Stack>
    );
  }

  return (
    <SimpleGrid columns={3} gap={2} py={3} maxW="full">
      {selectedContacts?.map(renderContactCard)}
    </SimpleGrid>
  );
};
